import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../services/api.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-login-pages',
  templateUrl: './login-pages.component.html',
  styleUrls: ['./login-pages.component.css']
})
export class LoginPagesComponent {
  

  signInSec:boolean = true;
  signUpSec:boolean = false;
  forgotPwdSec:boolean = false;
  updatePwdSce:boolean = false;
  verificationForm:boolean = false;
  resendCodeSuccess:boolean = false;
  verificationFailed:boolean = false;
  accountLocked:boolean = false;
  verificationErrorText:any;
  unauthorizedUser:boolean = false;
  invalidAuthorizetion:boolean = false;
  remainingAttempts:any;
  otpNotVerify:boolean = false;

  constructor(private apiService: ApiService){
    
  }
  ngOnInit(){
    //this.apiService.femsAccessToken();
  }

  signInForm = new FormGroup({
    signInEmail: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})')]),
    signInPWD:new FormControl('',[Validators.required,Validators.minLength(4),Validators.maxLength(50)]),
  });

  signUpForm = new FormGroup({
    signUpEmail: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})')]),
    signUpPwd:new FormControl('',[Validators.required,Validators.minLength(4),Validators.maxLength(50)]),
    //confirmPwd:new FormControl('',[Validators.required,Validators.minLength(4),Validators.maxLength(50)]),
    signUpFirstName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    signUpLastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    signUpCompanyName:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
    signUpPhoneNum: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
    
  });

  forgotPwdForm = new FormGroup({
    forgotPwdEmail: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})')]),
  });

  updatePwdForm = new FormGroup({
    newPwd:new FormControl('',[Validators.required,Validators.minLength(4),Validators.maxLength(50)]),
    confirmNewPwd:new FormControl('',[Validators.required,Validators.minLength(4),Validators.maxLength(50)]),
  });

  verificationFormGroup = new FormGroup({
    vCode1: new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(1)]),
    vCode2: new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(1)]),
    vCode3: new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(1)]),
    vCode4: new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(1)]),
    vCode5: new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(1)]),
    vCode6: new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(1)]),
  });

  signin_validation_messages = {
    'signInEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'signInPWD':[
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 50 characters long.' },
      //{ type: 'pattern', message: 'Please enter a valid email.' }
    ]
  }
  signup_validation_messages = {
    'signUpEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'signUpPwd':[
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 50 characters long.' },
      //{ type: 'pattern', message: 'Please enter a valid email.' }
    ],
    // 'confirmPwd':[
    //   { type: 'required', message: 'Confirm Password is required.' },
    //   { type: 'minlength', message: 'Confirm Password must be at least 5 characters long.' },
    //   { type: 'maxlength', message: 'Confirm Password cannot be more than 50 characters long.' },
    // ],
    'signUpFirstName': [
      { type: 'required', message: 'first name is required.' },
      { type: 'minlength', message: 'first name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'first name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your first name must contain only letters.' }
    ],
    'signUpLastName': [
      { type: 'required', message: 'last name is required.' },
      { type: 'minlength', message: 'last name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'last name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your last name must contain only letters.' }
    ],
    'signUpCompanyName': [
      { type: 'required', message: 'company name is required.' },
      { type: 'minlength', message: 'company name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'company name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your company name must contain only letters.' }
    ],
    'signUpPhoneNum': [
      { type: 'required', message: 'phone number is required.' },
      { type: 'minlength', message: 'phone number must be at least 10 numeric long.' },
      { type: 'maxlength', message: 'phone number cannot be more than 10 numeric long.' }
    ]
  }
  forgot_validation_messages = {
    'forgotPwdEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ]
  }
  update_password_validation_messages = {
    'newPwd':[
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 50 characters long.' },
      //{ type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'confirmNewPwd':[
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 50 characters long.' },
      //{ type: 'pattern', message: 'Please enter a valid email.' }
    ]
  }

  gotoSignup(){
    this.signInSec = false;
    this.signUpSec = true;
    this.forgotPwdSec = false;
    this.updatePwdSce = false;
  }
  gotoSignIn(){
    this.signInSec = true;
    this.signUpSec = false;
    this.forgotPwdSec = false;
    this.updatePwdSce = false;
  }
  gotoForgotPwd(){
    this.signInSec = false;
    this.signUpSec = false;
    this.forgotPwdSec = true;
    this.updatePwdSce = false;
  }
  updatePassword(){

  }

  signIn(){
    this.unauthorizedUser = false;
    this.invalidAuthorizetion = false;
    console.log(this.signInForm);
    var loginObj = {
        "loginDto": {
          "memberID": this.signInForm.controls.signInEmail.value,
          "password": this.signInForm.controls.signInPWD.value
        },
        "rgisterUser": {
            "companyName": "",
            "email": "",
            "firstName": "",
            "lastName": "",
            "memberId": "",
            "password": "",
            "phoneNumber": ""
        }
    }
    
    this.apiService.userSignInorSignUp(loginObj).subscribe((data:any) => {
      console.log("LoginData", data);
      var loginData = data.loginResponseObject;
      if(loginData.userID == null && loginData.failedLoginAttemptCount == 0){
        this.unauthorizedUser = true;
        $('#Login_Password').val('');
      }else if(loginData.userID == null && loginData.failedLoginAttemptCount > 0){
        this.invalidAuthorizetion = true;
        $('#Login_Password').val('');
      }else if(loginData.userID){
        this.signInForm.reset();
      }
      if(loginData.userID == null){
        this.remainingAttempts = 5 - loginData.failedLoginAttemptCount;
        if(loginData.failedLoginAttemptCount == 5 && loginData.userLockedForMaxFailedLoginAttempts == true){
          this.verificationForm = false;
          this.accountLocked =  true;
          this.signInSec = false;
          this.signUpSec = false;
          this.forgotPwdSec = false;
          this.updatePwdSce = false;
        }
      }
      if(loginData.userID && loginData.passwordResetFlag == false){
        //this.remoteService.loginAccessToken = data.access_token;
        //Start After verification this loginCheck making true
        //this.remoteService.logincheck = true;
        //End
        //this.localStoreData = JSON.parse(localStorage.getItem('quoteData'));
        //this.localStoreData['userId'] = data.userID;
        //this.remoteService.kicad_uid = this.localStoreData['userId'];
        //localStorage.setItem('quoteData',JSON.stringify(this.localStoreData));
        //console.log("localStoreData",this.localStoreData);
        if(loginData.isOtpSentToUserMail == true && (loginData.isOtpNotYetVerifiedForTheLastLogin == false || loginData.isOtpNotYetVerifiedForTheLastLogin == true)){
          if(loginData.statusMessage == "Otp is not yet verified for the last login, please verify otp or click on resend the otp if otp is not sent to you."){
            this.otpNotVerify = true;
          }
          this.verificationForm = true;
          this.accountLocked =  false;
          this.signInSec = false;
          this.signUpSec = false;
          this.forgotPwdSec = false;
          this.updatePwdSce = false;
        }else if(loginData.isOtpSentToUserMail == false){
          // this.remoteService.logincheck = true;
          // this.remoteService.getUserProfileBy_KicadUser();
          // this.modelController.dismiss();
        }
      }
      if(loginData.userID && loginData.passwordResetFlag == true){
        //this.remoteService.loginAccessToken = data.access_token;
        //this.localStoreData = JSON.parse(localStorage.getItem('quoteData'));
        //this.localStoreData['userId'] = data.userID;
        //this.remoteService.kicad_uid = this.localStoreData['userId'];
        //localStorage.setItem('quoteData',JSON.stringify(this.localStoreData));
        //console.log("localStoreData",this.localStoreData);
        this.verificationForm = false;
        this.accountLocked =  false;
        this.signInSec = false;
        this.signUpSec = false;
        this.forgotPwdSec = false;
        this.updatePwdSce = true;
        return;
      }

    },error => {
      console.log(error);
    });
  }
  signUp(){
    var signUpObj = {
      "loginDto": {
        "memberID": "",
        "password": ""
      },
      "rgisterUser": {
          "companyName": this.signUpForm.controls.signUpCompanyName.value,
          "email": this.signUpForm.controls.signUpEmail.value,
          "firstName": this.signUpForm.controls.signUpFirstName.value,
          "lastName": this.signUpForm.controls.signUpLastName.value,
          "memberId": this.signUpForm.controls.signUpEmail.value,
          "password": this.signUpForm.controls.signUpPwd.value,
          "phoneNumber": this.signUpForm.controls.signUpPhoneNum.value
      }
    }

    this.apiService.userSignInorSignUp(signUpObj).subscribe((data:any) => {
      console.log("signUpdata", data);
      var loginData = data.loginResponseObject;
      // if(data){
      //   this.signInSec = true;
      //   this.signUpSec = false;
      //   this.forgotPwdSec = false;
      //   this.updatePwdSce = false;
      // }
      // if(data.errorMessage){
      //   this.apiService.hideLoader();
      //   if(data.errorMessage == "MemberID already exists"){
      //     this.remoteService.alertCall('Warning!',"Email ID already exists",);
      //   }else if(data.errorMessage != "MemberID already exists"){
      //     this.remoteService.alertCall('Warning!',data.errorMessage,);
      //   }
      //   return false;
      // }
      if(loginData.userID){
        //things need to check is do need to call profile API
      }
    },error => {
      console.log(error);
      if(error.status == 409){
        alert(error.error.message);
      }
      
  
      //this.loginConsignedObj = {'username':'','password':''};
    });
  }

  forgotPwd(){
    var Email = this.forgotPwdForm.controls.forgotPwdEmail.value;
    
      this.apiService.forgotPassword(Email).then((res: any)=>{
        if(res.status == 200){
          alert('Password reset success. Please check email for your new password.');
        }else if(res.status == 400){
          alert('Warning! Email is not registered');
        }else{
          alert('Warning! Please check entered email');
        }
      });
  }

  verifyOtp(){
    
    
    var v1:any = $('#otp1').val();
    var v2:any = $('#otp2').val();
    var v3:any = $('#otp3').val();
    var v4:any = $('#otp4').val();
    var v5:any = $('#otp5').val();
    var v6:any = $('#otp6').val();
    var vCodePart1 = v1+v2+v3;
    var vCodePart2 = v4+v5+v6;
    var codeObj = {
      "otp":(vCodePart1.toUpperCase( ))+'-'+(vCodePart2.toUpperCase()),
      "otpForLogin":true
    }
    this.verificationFailed = false;
    this.resendCodeSuccess = false;
    this.otpNotVerify = false;
    this.apiService.verifyCode(codeObj).subscribe((data:any) => {
      //   this.remoteService.getUserProfileBy_KicadUser();
      if(data.userID == null && data.statusMessage == "Invalid Code Entered. Please try again."){
        this.verificationFailed = true;
      }
    },error => {
      //this.remoteService.hideLoader();
      console.log(error);
      if(error.status == 200){
        this.verificationFailed = true;
        $('#otp1').val('');
        $('#otp2').val('');
        $('#otp3').val('');
        $('#otp4').val('');
        $('#otp5').val('');
        $('#otp6').val('');
        this.verificationErrorText = error.error.text;
      }
      if (error.status == 500) {
        //this.remoteService.alertCall('Warning!',error.error.errorMessage,);
      }
    });
  }

  resendNewCode(){
    this.apiService.resendCode().subscribe((data:any) => {
      this.verificationFailed = false;
      this.otpNotVerify = false;
      this.resendCodeSuccess = true;
      $('#otp1').val('');
      $('#otp2').val('');
      $('#otp3').val('');
      $('#otp4').val('');
      $('#otp5').val('');
      $('#otp6').val('');
    },error => {
      console.log(error);
      if (error.status == 500) {
        //this.apiService.alertCall('Warning!',error.error.errorMessage,);
      }
    });
  }

  otpController(event:any,prev:any,curr:any,next:any){
    var length = curr.value.length;
    var maxlength = curr.getAttribute('maxlength');
    if(length  == maxlength){
      if(next != ''){
        next.focus();
      }
    }
    if(event.key === "Backspace"){
      if(prev != ''){
        prev.focus();
      } 
    }
  }

  closeAccountLockScreen(){
    this.accountLocked =  false;
    this.signInSec = true;
    this.verificationForm = false;
  }
}


